import React, {
  FC, memo, useEffect, useState, useCallback, 
} from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Link as ScrollLink } from 'react-scroll';
import { useLocation, useNavigate } from 'react-router-dom';
import { PathName } from 'appConstants';

import styles from './styles.module.scss';

interface ILinksOthers {
  links: { link: string, title: string }[];
  showRoadmap?: boolean;
  classNameContainer?: string;
  isHeaderLink?: boolean;
}

export const LinksOthers: FC<ILinksOthers> = memo(
  ({
    links, showRoadmap, classNameContainer, isHeaderLink, 
  }) => {
    const { t: tFooter } = useTranslation('footer');
    const { t: tHeader } = useTranslation('header');

    const navigate = useNavigate();
    const { pathname: currentPath } = useLocation();
    const referralFromURL = window?.location?.search;

    const lng = localStorage.getItem('lng') || 'en';
    const locale = localStorage.getItem('locale') || 'en';
    const [roadmapLanguage, setRoadmapLanguage] = useState(lng || locale);

    useEffect(() => setRoadmapLanguage(lng), [lng]);

    const handleScrollToMainPage = useCallback(
      (pathName: string) => {
        if (currentPath !== PathName.Home) {
          navigate(`${PathName.Home}${referralFromURL}`, {
            state: { scrollTo: pathName },
          });
        }
      },
      [currentPath, navigate, referralFromURL],
    );

    useEffect(() => {
      const target = (window.history.state)?.usr?.scrollTo;
      if (currentPath === PathName.Home && target) {
        setTimeout(() => {
          const element = document.getElementById(target);
          element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
      }
    }, [currentPath]);

    return (
      <div className={cn(styles.footer_others, classNameContainer)}>
        {links.map(({ link, title }) =>
          (isHeaderLink ? (
            <ScrollLink
              key={title}
              to={link}
              smooth
              offset={-100}
              onClick={() => handleScrollToMainPage(link)}
              className={styles.footer_navigation_link}
            >
              {tHeader(title)}
            </ScrollLink>
          ) : (
            <a
              key={title}
              href={link}
              target="_blank"
              rel="noreferrer"
              className={styles.footer_navigation_link}
            >
              {tFooter(title)}
            </a>
          )))}

        {showRoadmap && (
          <a
            href={`https://storage.googleapis.com/eclipse-cdn/files/Roadmap_${roadmapLanguage}.pdf`}
            target="_blank"
            rel="noreferrer"
            className={styles.footer_navigation_link}
          >
            Roadmap
          </a>
        )}
      </div>
    );
  },
);
